module.exports = __webpack_public_path__ + "static/img/tzgg.6647528d.svg";